import { render } from "./InteractiveImage.vue?vue&type=template&id=2615496b&scoped=true"
import script from "./InteractiveImage.vue?vue&type=script&lang=js"
export * from "./InteractiveImage.vue?vue&type=script&lang=js"

import "./InteractiveImage.vue?vue&type=style&index=0&id=2615496b&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2615496b"]])

export default __exports__